import api from "../axiosConfig";

export const fetchEditPermissions = async () => {
  try {
    const response = await api.get("/api/editPermission");
    return response.data;
  } catch (error) {
    console.error("Error fetching edit permissions:", error);
    return {
      Current_Month: 0,
      Future_Month: 0,
      Scheme: 0,
      Current_Month_Cell: 0,
      Future_Month_Cell: 0,
    };
  }
};